import { useState } from "react";
import { getDefaultDateRange } from "../constants/chartOptions";

/**
 * Custom hook for managing chart controls state
 */
export const useChartControls = () => {
  const [statType, setStatType] = useState("recurringSubscriptions");
  const [statPeriod, setStatPeriod] = useState("byDays");
  const [openRangeDialog, setOpenRangeDialog] = useState(false);
  const [defaultRange, setDefaultRange] = useState(true);
  const [selectionRange, setSelectionRange] = useState(
    getDefaultDateRange("byDays")
  );

  const handleStatType = (e) => {
    setStatType(e.target.value);
  };

  const handleStatPeriod = (e) => {
    const newPeriod = e.target.value;
    setStatPeriod(newPeriod);
    
    if (defaultRange) {
      const newRange = getDefaultDateRange(newPeriod);
      setSelectionRange(newRange);
    }
  };

  const handleRangeChange = (ranges) => {
    setDefaultRange(false);
    setSelectionRange(ranges.range1);
  };

  const handleReset = () => {
    setDefaultRange(true);
    setSelectionRange(getDefaultDateRange(statPeriod));
  };

  return {
    statType,
    statPeriod,
    selectionRange,
    openRangeDialog,
    defaultRange,
    setOpenRangeDialog,
    handleStatType,
    handleStatPeriod,
    handleRangeChange,
    handleReset,
  };
};

